





















































import { Vue, Component } from "vue-property-decorator";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import {
  PracticePassEditStatusEnum,
  PracticePassEdit as IPracticePassEdit
} from "@/api/models/practice-pass-edit";
import { isRoot, getCurrentUserId, getCurrentCompanyId } from "@/plugins/roles";
import api from "@/getinfo-api";
import PracticePassResult from "@/components/practice/PracticePassResult.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { PracticePassAnswer as IPracticePassAnswer } from "@/api/models/practice-pass-answer";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, EditorWithFile, PracticePassResult }
})
export default class PracticePass extends Vue {
  practicePass!: IPracticePass;
  comment!: string;
  body!: string;

  data() {
    return {
      practicePass: undefined,
      comment: undefined,
      body: undefined
    };
  }

  get isHasCompany() {
    return !!getCurrentCompanyId();
  }

  get breadcrumbsForEmployee() {
    return [
      {
        to: { name: "practiceList" },
        label: this.$tc(this.$translate.PracticeAssignmentResults)
      },
      {
        label: this.$converter.limitedOutput(
          this.practicePass.listener.course.title,
          40
        )
      }
    ];
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "myPractices" },
        label: this.$tc(this.$translate.MyPracticeAssignmentResults)
      },
      {
        label: this.$converter.limitedOutput(
          this.practicePass.listener.course.title,
          40
        )
      }
    ];
  }

  get currentListener() {
    return this.practicePass?.listener.user.id === this.userId;
  }

  get status() {
    return PracticePassEditStatusEnum;
  }

  sendNewPracticePass() {
    if (this.practicePass) {
      let params: IPracticePassAnswer = {
        body: this.body
      };

      api.PracticeApi.pass(this.practicePass.listener.course.id, params)
        .then(() => {
          this.$router.push({ name: "myPractices" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  changeStatus(status: PracticePassEditStatusEnum) {
    let params: IPracticePassEdit = {
      status: status,
      comment: this.comment ? this.comment : undefined
    };
    api.PracticeApi.editPass(
      this.$route.params.courseId,
      this.$route.params.listenerId,
      params
    )
      .then(() => {
        this.$router.push({ name: "practiceList" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  getPracticePass() {
    api.PracticeApi.getPassByListener(
      this.$route.params.courseId,
      this.$route.params.listenerId
    ).then((res: { data: IPracticePass }) => {
      this.practicePass = res.data;
      this.body = this.practicePass.body;
      document.title += ` ${this.practicePass.listener.course.title}`;
    });
  }

  get root() {
    return isRoot();
  }

  get companyCourseOwner() {
    return (
      this.userId === this.practicePass?.listener?.course?.company?.owner?.id
    );
  }

  get courseOwner() {
    return this.userId === this.practicePass?.listener?.course?.owner?.id;
  }

  get userId() {
    return getCurrentUserId();
  }

  mounted() {
    this.getPracticePass();
  }
}
